export default __webpack_public_path__ + "static/media/visa.c7ab9d23.png";